
// Actions
const PREFIX = 'calculus/translations/';

export const SET_TRANSLATIONS  = PREFIX + 'SET_TRANSLATIONS';

const INITIAL_STATE = {
  loading: true,
  data: []
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_TRANSLATIONS:
      return {
        ...state,
        data: payload,
        loading: false
      };

    default:
      return state;
  }
}

// Action Creators
export function setTranslations(payload) {
  return {
    type: SET_TRANSLATIONS,
    payload: payload
  };
}
